import { Api } from '$api';

import { toUtcDayStart } from './utils/dateRange';

export interface LinkMeta {
  id: number;
  name: string;
}

export interface LinkJoinRow {
  date: number;
  linkId: number;
  count: number;
}

export interface LinksStatsResult {
  links: LinkMeta[];
  rows: LinkJoinRow[];
}

interface RawLinksStatsResponse {
  links?: LinkMeta[] | null;
  rows?: LinkJoinRow[] | null;
}

export async function fetchLinksStats(query: {
  from: number;
  to: number;
  promoLinkIds?: number[];
}): Promise<LinksStatsResult> {
  const data: RawLinksStatsResponse = await Api.get('/stats/pro/links', {
    params: {
      from: toUtcDayStart(query.from),
      to: toUtcDayStart(query.to),
      promoLinkIds: query.promoLinkIds?.length ? query.promoLinkIds.join(',') : undefined,
    },
  });

  return {
    links: data?.links ?? [],
    rows: data?.rows ?? [],
  };
}
